import React from "react"
import styled from "styled-components"

import { H2, P, Container, ButtonLink } from "../general/GeneralStyles"

const LearnMore = styled(Container)`
  max-width: 1800px;
  width: 100%;
  text-align: center;
  color: white;
  background: url("/images/upcs.png");
  background-position: center;
  background-size: 1400px;
  background-repeat: no-repeat;
  padding: 120px 0;
  margin: 80px auto 90px auto;

  ${P} {
    max-width: 600px;
    margin: 0 auto;
    color: white;
    margin-bottom: 25px;
  }

  ${H2} {
    color: white;
  }
`

const LearnMoreCTA = props => {
  return (
    <LearnMore>
      <H2> How Does Prang Power Work?</H2>
      <P>
        The Prang Power program allows you to earn points by turning in the UPC
        codes from any Dixon, Ticonderoga, Prang, and Lyra product. These points
        can be banked and redeemed for free school and art supplies.
      </P>
      <ButtonLink to="/how-it-works">Learn More</ButtonLink>
    </LearnMore>
  )
}

export default LearnMoreCTA
